export const changeDate = (
  dates: [Date | null, Date | null],
  setStartDate: React.Dispatch<React.SetStateAction<Date | null>>,
  setEndDate: React.Dispatch<React.SetStateAction<Date | null>>
) => {
  const [start, end] = dates;
  setStartDate(start);
  setEndDate(end);
};
